//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './Client'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export type BoatsGETQueryParameters = {
  pageNumber?: number | undefined ;
  pageSize?: number | undefined ;
  search?: string | undefined ;
  markets?: string[] | undefined ;
  ownerGuid?: string | undefined ;
  skipperGuid?: string | undefined ;
  sortBy?: Types.BoatSortOptions | undefined ;
  descending?: boolean | undefined ;
}

export type BoatsGuidGETQueryParameters = {
  guidPath: string ;
  guidQuery?: string | undefined ;
}

export type BoatsGuidGalleryGETQueryParameters = {
  guid: string ;
}

export type BoatsByLocationLocationguidGETQueryParameters = {
  locationGuid: string ;
  pageNumber?: number | undefined ;
  pageSize?: number | undefined ;
}

export type BoatsPublishedGETQueryParameters = {
  pageNumber?: number | undefined ;
  pageSize?: number | undefined ;
  markets?: string[] | undefined ;
}

export type BookingsByCreationDateRangeGETQueryParameters = {
  pageNumber?: number | undefined ;
  pageSize?: number | undefined ;
  dateFrom?: Date | undefined ;
  dateTo?: Date | undefined ;
}

export type BookingsGuidGETQueryParameters = {
  guid: string ;
}

export type BookingsGuidCustomerGETQueryParameters = {
  guid: string ;
}

export type CustomersCustomerguidWorldpayCustomerIdGETQueryParameters = {
  customerGuid: string ;
}

export type ListingsGuidGETQueryParameters = {
  guid: string ;
}

export type ListingsGuidCalendarDaysGETQueryParameters = {
  guid: string ;
  from?: Date | undefined ;
  to?: Date | undefined ;
}

export type ListingsGuidCalendarDayPricingsGETQueryParameters = {
  guid: string ;
  date?: Date | undefined ;
}

export type ListingsAvailableListingsDetailsGETQueryParameters = {
  pageNumber?: number | undefined ;
  pageSize?: number | undefined ;
  date?: Date | undefined ;
  marketTitle?: string | undefined ;
  boatGuids?: string[] | undefined ;
}

export type OwnersGuidGETQueryParameters = {
  guid: string ;
}


export type PaymentsGuidGETQueryParameters = {
  guid: string ;
}


export type PaymentsAuthorize_NetCheckoutSessionGuidGETQueryParameters = {
  guid: string ;
}

export type PaymentsStatusGETQueryParameters = {
  guid?: string | undefined ;
}

export type PaymentsWorldpayCheckoutSessionGuidGETQueryParameters = {
  guid: string ;
}

export type PaymentsIntent__DebugPOSTQueryParameters = {
  paymentIntentId?: string | undefined ;
  paymentIntentEventType?: string | undefined ;
}

export type PaymentsCheckoutSession__DebugPOSTQueryParameters = {
  sessionId?: string | undefined ;
  amountTotal?: number | undefined ;
}

export type PricingsCalculateGETQueryParameters = {
  pricingGuid?: string | undefined ;
  passengers?: number | undefined ;
  promoCodeRequest_PromoCode?: string | undefined ;
  promoCodeRequest_StartDateTime?: Date | undefined ;
  campaignCodeRequest_Code?: string | undefined ;
  campaignCodeRequest_StartDateTime?: Date | undefined ;
}

export type PricingsGuidPromoCodeValidationPOSTQueryParameters = {
  guid: string ;
}

export type PricingsGuidCampaignValidationPOSTQueryParameters = {
  guid: string ;
}

export type PricingsGuidCampaignValidationByCustomerEmailPOSTQueryParameters = {
  guid: string ;
}

export function additionalFeesGETUrl(): string {
  let url_ = getBaseUrl() + "/additional-fees";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let additionalFeesGETDefaultOptions: Omit<UseQueryOptions<Types.GetAllAdditionalFeeTypesQueryResult, unknown, Types.GetAllAdditionalFeeTypesQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetAllAdditionalFeeTypesQueryResult, unknown, Types.GetAllAdditionalFeeTypesQueryResult>, 'queryFn'>> = {
};
export function getAdditionalFeesGETDefaultOptions() {
  return additionalFeesGETDefaultOptions;
};
export function setAdditionalFeesGETDefaultOptions(options: typeof additionalFeesGETDefaultOptions) {
  additionalFeesGETDefaultOptions = options;
}

export function additionalFeesGETQueryKey(): QueryKey;
export function additionalFeesGETQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'Client',
      'additionalFeesGET',
    ]);
}
export function __additionalFeesGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.additionalFeesGET(
axiosConfig    );
}

/**
 * @return Success
 */
export function useAdditionalFeesGETQuery<TSelectData = Types.GetAllAdditionalFeeTypesQueryResult, TError = unknown>(options?: Omit<UseQueryOptions<Types.GetAllAdditionalFeeTypesQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAdditionalFeesGETQuery<TSelectData = Types.GetAllAdditionalFeeTypesQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetAllAdditionalFeeTypesQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetAllAdditionalFeeTypesQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __additionalFeesGET(context, axiosConfig) : __additionalFeesGET,
    queryKey: additionalFeesGETQueryKey(),
    ...additionalFeesGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetAllAdditionalFeeTypesQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setAdditionalFeesGETData(queryClient: QueryClient, updater: (data: Types.GetAllAdditionalFeeTypesQueryResult | undefined) => Types.GetAllAdditionalFeeTypesQueryResult, ) {
  queryClient.setQueryData(additionalFeesGETQueryKey(),
    updater
  );
}

/**
 * @return Success
 */
export function setAdditionalFeesGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetAllAdditionalFeeTypesQueryResult | undefined) => Types.GetAllAdditionalFeeTypesQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function authenticationUserExchangeMagicTokenPOSTUrl(): string {
  let url_ = getBaseUrl() + "/authentication-user/exchange-magic-token";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function authenticationUserExchangeMagicTokenPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'authenticationUserExchangeMagicTokenPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function useAuthenticationUserExchangeMagicTokenPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.GenerateAuthenticationUserJwtFromMagicTokenCommandResult, unknown, Types.GenerateAuthenticationUserJwtFromMagicTokenCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.GenerateAuthenticationUserJwtFromMagicTokenCommandResult, unknown, Types.GenerateAuthenticationUserJwtFromMagicTokenCommand, TContext> {
  const key = authenticationUserExchangeMagicTokenPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.GenerateAuthenticationUserJwtFromMagicTokenCommand) => Client.authenticationUserExchangeMagicTokenPOST(body),
    mutationKey: key,
  });
}
  
export function authenticationUserRequestMagicLinkPOSTUrl(): string {
  let url_ = getBaseUrl() + "/authentication-user/request-magic-link";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function authenticationUserRequestMagicLinkPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'authenticationUserRequestMagicLinkPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function useAuthenticationUserRequestMagicLinkPOSTMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.RequestMagicLinkByBookingGuidCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.RequestMagicLinkByBookingGuidCommand, TContext> {
  const key = authenticationUserRequestMagicLinkPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.RequestMagicLinkByBookingGuidCommand) => Client.authenticationUserRequestMagicLinkPOST(body),
    mutationKey: key,
  });
}
  
export function boatsGETUrl(pageNumber?: number | undefined, pageSize?: number | undefined, search?: string | undefined, markets?: string[] | undefined, ownerGuid?: string | undefined, skipperGuid?: string | undefined, sortBy?: Types.BoatSortOptions | undefined, descending?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/boats?";
if (pageNumber === null)
    throw new Error("The parameter 'pageNumber' cannot be null.");
else if (pageNumber !== undefined)
    url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
if (pageSize === null)
    throw new Error("The parameter 'pageSize' cannot be null.");
else if (pageSize !== undefined)
    url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
if (search === null)
    throw new Error("The parameter 'search' cannot be null.");
else if (search !== undefined)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (markets === null)
    throw new Error("The parameter 'markets' cannot be null.");
else if (markets !== undefined)
    markets && markets.forEach(item => { url_ += "Markets=" + encodeURIComponent("" + item) + "&"; });
if (ownerGuid === null)
    throw new Error("The parameter 'ownerGuid' cannot be null.");
else if (ownerGuid !== undefined)
    url_ += "OwnerGuid=" + encodeURIComponent("" + ownerGuid) + "&";
if (skipperGuid === null)
    throw new Error("The parameter 'skipperGuid' cannot be null.");
else if (skipperGuid !== undefined)
    url_ += "SkipperGuid=" + encodeURIComponent("" + skipperGuid) + "&";
if (sortBy === null)
    throw new Error("The parameter 'sortBy' cannot be null.");
else if (sortBy !== undefined)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (descending === null)
    throw new Error("The parameter 'descending' cannot be null.");
else if (descending !== undefined)
    url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let boatsGETDefaultOptions: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryFn'>> = {
};
export function getBoatsGETDefaultOptions() {
  return boatsGETDefaultOptions;
};
export function setBoatsGETDefaultOptions(options: typeof boatsGETDefaultOptions) {
  boatsGETDefaultOptions = options;
}

export function boatsGETQueryKey(dto: BoatsGETQueryParameters): QueryKey;
export function boatsGETQueryKey(pageNumber?: number | undefined, pageSize?: number | undefined, search?: string | undefined, markets?: string[] | undefined, ownerGuid?: string | undefined, skipperGuid?: string | undefined, sortBy?: Types.BoatSortOptions | undefined, descending?: boolean | undefined): QueryKey;
export function boatsGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { pageNumber, pageSize, search, markets, ownerGuid, skipperGuid, sortBy, descending,  } = params[0] as BoatsGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'boatsGET',
        pageNumber as any,
        pageSize as any,
        search as any,
        markets as any,
        ownerGuid as any,
        skipperGuid as any,
        sortBy as any,
        descending as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'boatsGET',
        ...params
      ]);
  }
}
export function __boatsGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.boatsGET(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as string[] | undefined,       context.queryKey[6] as string | undefined,       context.queryKey[7] as string | undefined,       context.queryKey[8] as Types.BoatSortOptions | undefined,       context.queryKey[9] as boolean | undefined,axiosConfig    );
}

export function useBoatsGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(dto: BoatsGETQueryParameters, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param search (optional) 
 * @param markets (optional) 
 * @param ownerGuid (optional) 
 * @param skipperGuid (optional) 
 * @param sortBy (optional) 
 * @param descending (optional) 
 * @return Success
 */
export function useBoatsGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(pageNumber?: number | undefined, pageSize?: number | undefined, search?: string | undefined, markets?: string[] | undefined, ownerGuid?: string | undefined, skipperGuid?: string | undefined, sortBy?: Types.BoatSortOptions | undefined, descending?: boolean | undefined, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBoatsGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let pageNumber: any = undefined;
  let pageSize: any = undefined;
  let search: any = undefined;
  let markets: any = undefined;
  let ownerGuid: any = undefined;
  let skipperGuid: any = undefined;
  let sortBy: any = undefined;
  let descending: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ pageNumber, pageSize, search, markets, ownerGuid, skipperGuid, sortBy, descending,  } = params[0] as BoatsGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [pageNumber, pageSize, search, markets, ownerGuid, skipperGuid, sortBy, descending, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __boatsGET(context, axiosConfig) : __boatsGET,
    queryKey: boatsGETQueryKey(pageNumber, pageSize, search, markets, ownerGuid, skipperGuid, sortBy, descending),
    ...boatsGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param search (optional) 
 * @param markets (optional) 
 * @param ownerGuid (optional) 
 * @param skipperGuid (optional) 
 * @param sortBy (optional) 
 * @param descending (optional) 
 * @return Success
 */
export function setBoatsGETData(queryClient: QueryClient, updater: (data: Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, pageNumber?: number | undefined, pageSize?: number | undefined, search?: string | undefined, markets?: string[] | undefined, ownerGuid?: string | undefined, skipperGuid?: string | undefined, sortBy?: Types.BoatSortOptions | undefined, descending?: boolean | undefined) {
  queryClient.setQueryData(boatsGETQueryKey(pageNumber, pageSize, search, markets, ownerGuid, skipperGuid, sortBy, descending),
    updater
  );
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param search (optional) 
 * @param markets (optional) 
 * @param ownerGuid (optional) 
 * @param skipperGuid (optional) 
 * @param sortBy (optional) 
 * @param descending (optional) 
 * @return Success
 */
export function setBoatsGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function boatsGuidGETUrl(guidPath: string, guidQuery?: string | undefined): string {
  let url_ = getBaseUrl() + "/boats/{guid}?";
if (guidPath === undefined || guidPath === null)
  throw new Error("The parameter 'guidPath' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guidPath));
if (guidQuery === null)
    throw new Error("The parameter 'guidQuery' cannot be null.");
else if (guidQuery !== undefined)
    url_ += "guid=" + encodeURIComponent("" + guidQuery) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let boatsGuidGETDefaultOptions: Omit<UseQueryOptions<Types.GetBoatQueryResult, unknown, Types.GetBoatQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetBoatQueryResult, unknown, Types.GetBoatQueryResult>, 'queryFn'>> = {
};
export function getBoatsGuidGETDefaultOptions() {
  return boatsGuidGETDefaultOptions;
};
export function setBoatsGuidGETDefaultOptions(options: typeof boatsGuidGETDefaultOptions) {
  boatsGuidGETDefaultOptions = options;
}

export function boatsGuidGETQueryKey(dto: BoatsGuidGETQueryParameters): QueryKey;
export function boatsGuidGETQueryKey(guidPath: string, guidQuery?: string | undefined): QueryKey;
export function boatsGuidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guidPath, guidQuery,  } = params[0] as BoatsGuidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'boatsGuidGET',
        guidPath as any,
        guidQuery as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'boatsGuidGET',
        ...params
      ]);
  }
}
export function __boatsGuidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.boatsGuidGET(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useBoatsGuidGETQuery<TSelectData = Types.GetBoatQueryResult, TError = unknown>(dto: BoatsGuidGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetBoatQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param guidQuery (optional) 
 * @return Success
 */
export function useBoatsGuidGETQuery<TSelectData = Types.GetBoatQueryResult, TError = unknown>(guidPath: string, guidQuery?: string | undefined, options?: Omit<UseQueryOptions<Types.GetBoatQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBoatsGuidGETQuery<TSelectData = Types.GetBoatQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetBoatQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guidPath: any = undefined;
  let guidQuery: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guidPath, guidQuery,  } = params[0] as BoatsGuidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guidPath, guidQuery, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetBoatQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __boatsGuidGET(context, axiosConfig) : __boatsGuidGET,
    queryKey: boatsGuidGETQueryKey(guidPath, guidQuery),
    ...boatsGuidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetBoatQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param guidQuery (optional) 
 * @return Success
 */
export function setBoatsGuidGETData(queryClient: QueryClient, updater: (data: Types.GetBoatQueryResult | undefined) => Types.GetBoatQueryResult, guidPath: string, guidQuery?: string | undefined) {
  queryClient.setQueryData(boatsGuidGETQueryKey(guidPath, guidQuery),
    updater
  );
}

/**
 * @param guidQuery (optional) 
 * @return Success
 */
export function setBoatsGuidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetBoatQueryResult | undefined) => Types.GetBoatQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function boatsGuidGalleryGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/boats/{guid}/gallery";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let boatsGuidGalleryGETDefaultOptions: Omit<UseQueryOptions<Types.GetBoatGalleryQueryResult, unknown, Types.GetBoatGalleryQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetBoatGalleryQueryResult, unknown, Types.GetBoatGalleryQueryResult>, 'queryFn'>> = {
};
export function getBoatsGuidGalleryGETDefaultOptions() {
  return boatsGuidGalleryGETDefaultOptions;
};
export function setBoatsGuidGalleryGETDefaultOptions(options: typeof boatsGuidGalleryGETDefaultOptions) {
  boatsGuidGalleryGETDefaultOptions = options;
}

export function boatsGuidGalleryGETQueryKey(guid: string): QueryKey;
export function boatsGuidGalleryGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as BoatsGuidGalleryGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'boatsGuidGalleryGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'boatsGuidGalleryGET',
        ...params
      ]);
  }
}
export function __boatsGuidGalleryGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.boatsGuidGalleryGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function useBoatsGuidGalleryGETQuery<TSelectData = Types.GetBoatGalleryQueryResult, TError = unknown>(dto: BoatsGuidGalleryGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetBoatGalleryQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function useBoatsGuidGalleryGETQuery<TSelectData = Types.GetBoatGalleryQueryResult, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetBoatGalleryQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBoatsGuidGalleryGETQuery<TSelectData = Types.GetBoatGalleryQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetBoatGalleryQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as BoatsGuidGalleryGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetBoatGalleryQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __boatsGuidGalleryGET(context, axiosConfig) : __boatsGuidGalleryGET,
    queryKey: boatsGuidGalleryGETQueryKey(guid),
    ...boatsGuidGalleryGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetBoatGalleryQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setBoatsGuidGalleryGETData(queryClient: QueryClient, updater: (data: Types.GetBoatGalleryQueryResult | undefined) => Types.GetBoatGalleryQueryResult, guid: string) {
  queryClient.setQueryData(boatsGuidGalleryGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setBoatsGuidGalleryGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetBoatGalleryQueryResult | undefined) => Types.GetBoatGalleryQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function boatsVisibleInCalendarGETUrl(): string {
  let url_ = getBaseUrl() + "/boats/visible-in-calendar";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let boatsVisibleInCalendarGETDefaultOptions: Omit<UseQueryOptions<Types.GetVisibleBoatsInCalendarQueryResult, unknown, Types.GetVisibleBoatsInCalendarQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetVisibleBoatsInCalendarQueryResult, unknown, Types.GetVisibleBoatsInCalendarQueryResult>, 'queryFn'>> = {
};
export function getBoatsVisibleInCalendarGETDefaultOptions() {
  return boatsVisibleInCalendarGETDefaultOptions;
};
export function setBoatsVisibleInCalendarGETDefaultOptions(options: typeof boatsVisibleInCalendarGETDefaultOptions) {
  boatsVisibleInCalendarGETDefaultOptions = options;
}

export function boatsVisibleInCalendarGETQueryKey(): QueryKey;
export function boatsVisibleInCalendarGETQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'Client',
      'boatsVisibleInCalendarGET',
    ]);
}
export function __boatsVisibleInCalendarGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.boatsVisibleInCalendarGET(
axiosConfig    );
}

/**
 * @return Success
 */
export function useBoatsVisibleInCalendarGETQuery<TSelectData = Types.GetVisibleBoatsInCalendarQueryResult, TError = unknown>(options?: Omit<UseQueryOptions<Types.GetVisibleBoatsInCalendarQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBoatsVisibleInCalendarGETQuery<TSelectData = Types.GetVisibleBoatsInCalendarQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetVisibleBoatsInCalendarQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetVisibleBoatsInCalendarQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __boatsVisibleInCalendarGET(context, axiosConfig) : __boatsVisibleInCalendarGET,
    queryKey: boatsVisibleInCalendarGETQueryKey(),
    ...boatsVisibleInCalendarGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetVisibleBoatsInCalendarQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setBoatsVisibleInCalendarGETData(queryClient: QueryClient, updater: (data: Types.GetVisibleBoatsInCalendarQueryResult | undefined) => Types.GetVisibleBoatsInCalendarQueryResult, ) {
  queryClient.setQueryData(boatsVisibleInCalendarGETQueryKey(),
    updater
  );
}

/**
 * @return Success
 */
export function setBoatsVisibleInCalendarGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetVisibleBoatsInCalendarQueryResult | undefined) => Types.GetVisibleBoatsInCalendarQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function boatsByLocationLocationguidGETUrl(locationGuid: string, pageNumber?: number | undefined, pageSize?: number | undefined): string {
  let url_ = getBaseUrl() + "/boats/by-location/{locationGuid}?";
if (locationGuid === undefined || locationGuid === null)
  throw new Error("The parameter 'locationGuid' must be defined.");
url_ = url_.replace("{locationGuid}", encodeURIComponent("" + locationGuid));
if (pageNumber === null)
    throw new Error("The parameter 'pageNumber' cannot be null.");
else if (pageNumber !== undefined)
    url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
if (pageSize === null)
    throw new Error("The parameter 'pageSize' cannot be null.");
else if (pageSize !== undefined)
    url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let boatsByLocationLocationguidGETDefaultOptions: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryFn'>> = {
};
export function getBoatsByLocationLocationguidGETDefaultOptions() {
  return boatsByLocationLocationguidGETDefaultOptions;
};
export function setBoatsByLocationLocationguidGETDefaultOptions(options: typeof boatsByLocationLocationguidGETDefaultOptions) {
  boatsByLocationLocationguidGETDefaultOptions = options;
}

export function boatsByLocationLocationguidGETQueryKey(dto: BoatsByLocationLocationguidGETQueryParameters): QueryKey;
export function boatsByLocationLocationguidGETQueryKey(locationGuid: string, pageNumber?: number | undefined, pageSize?: number | undefined): QueryKey;
export function boatsByLocationLocationguidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { locationGuid, pageNumber, pageSize,  } = params[0] as BoatsByLocationLocationguidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'boatsByLocationLocationguidGET',
        locationGuid as any,
        pageNumber as any,
        pageSize as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'boatsByLocationLocationguidGET',
        ...params
      ]);
  }
}
export function __boatsByLocationLocationguidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.boatsByLocationLocationguidGET(
      context.queryKey[2] as string,       context.queryKey[3] as number | undefined,       context.queryKey[4] as number | undefined,axiosConfig    );
}

export function useBoatsByLocationLocationguidGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(dto: BoatsByLocationLocationguidGETQueryParameters, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @return Success
 */
export function useBoatsByLocationLocationguidGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(locationGuid: string, pageNumber?: number | undefined, pageSize?: number | undefined, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBoatsByLocationLocationguidGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let locationGuid: any = undefined;
  let pageNumber: any = undefined;
  let pageSize: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ locationGuid, pageNumber, pageSize,  } = params[0] as BoatsByLocationLocationguidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [locationGuid, pageNumber, pageSize, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __boatsByLocationLocationguidGET(context, axiosConfig) : __boatsByLocationLocationguidGET,
    queryKey: boatsByLocationLocationguidGETQueryKey(locationGuid, pageNumber, pageSize),
    ...boatsByLocationLocationguidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @return Success
 */
export function setBoatsByLocationLocationguidGETData(queryClient: QueryClient, updater: (data: Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, locationGuid: string, pageNumber?: number | undefined, pageSize?: number | undefined) {
  queryClient.setQueryData(boatsByLocationLocationguidGETQueryKey(locationGuid, pageNumber, pageSize),
    updater
  );
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @return Success
 */
export function setBoatsByLocationLocationguidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetBoatsByLocationQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function boatsPublishedGETUrl(pageNumber?: number | undefined, pageSize?: number | undefined, markets?: string[] | undefined): string {
  let url_ = getBaseUrl() + "/boats/published?";
if (pageNumber === null)
    throw new Error("The parameter 'pageNumber' cannot be null.");
else if (pageNumber !== undefined)
    url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
if (pageSize === null)
    throw new Error("The parameter 'pageSize' cannot be null.");
else if (pageSize !== undefined)
    url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
if (markets === null)
    throw new Error("The parameter 'markets' cannot be null.");
else if (markets !== undefined)
    markets && markets.forEach(item => { url_ += "Markets=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let boatsPublishedGETDefaultOptions: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryFn'>> = {
};
export function getBoatsPublishedGETDefaultOptions() {
  return boatsPublishedGETDefaultOptions;
};
export function setBoatsPublishedGETDefaultOptions(options: typeof boatsPublishedGETDefaultOptions) {
  boatsPublishedGETDefaultOptions = options;
}

export function boatsPublishedGETQueryKey(dto: BoatsPublishedGETQueryParameters): QueryKey;
export function boatsPublishedGETQueryKey(pageNumber?: number | undefined, pageSize?: number | undefined, markets?: string[] | undefined): QueryKey;
export function boatsPublishedGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { pageNumber, pageSize, markets,  } = params[0] as BoatsPublishedGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'boatsPublishedGET',
        pageNumber as any,
        pageSize as any,
        markets as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'boatsPublishedGET',
        ...params
      ]);
  }
}
export function __boatsPublishedGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.boatsPublishedGET(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as string[] | undefined,axiosConfig    );
}

export function useBoatsPublishedGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(dto: BoatsPublishedGETQueryParameters, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param markets (optional) 
 * @return Success
 */
export function useBoatsPublishedGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(pageNumber?: number | undefined, pageSize?: number | undefined, markets?: string[] | undefined, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBoatsPublishedGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let pageNumber: any = undefined;
  let pageSize: any = undefined;
  let markets: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ pageNumber, pageSize, markets,  } = params[0] as BoatsPublishedGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [pageNumber, pageSize, markets, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __boatsPublishedGET(context, axiosConfig) : __boatsPublishedGET,
    queryKey: boatsPublishedGETQueryKey(pageNumber, pageSize, markets),
    ...boatsPublishedGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param markets (optional) 
 * @return Success
 */
export function setBoatsPublishedGETData(queryClient: QueryClient, updater: (data: Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, pageNumber?: number | undefined, pageSize?: number | undefined, markets?: string[] | undefined) {
  queryClient.setQueryData(boatsPublishedGETQueryKey(pageNumber, pageSize, markets),
    updater
  );
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param markets (optional) 
 * @return Success
 */
export function setBoatsPublishedGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetPublishedBoatsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function bookingsPOSTUrl(): string {
  let url_ = getBaseUrl() + "/bookings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function bookingsPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'bookingsPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function useBookingsPOSTMutation<TContext>(options?: Omit<UseMutationOptions<string, unknown, Types.CreateMarketplaceBookingCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, Types.CreateMarketplaceBookingCommand, TContext> {
  const key = bookingsPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.CreateMarketplaceBookingCommand) => Client.bookingsPOST(body),
    mutationKey: key,
  });
}
  
export function bookingsByCreationDateRangeGETUrl(pageNumber?: number | undefined, pageSize?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined): string {
  let url_ = getBaseUrl() + "/bookings/by-creation-date-range?";
if (pageNumber === null)
    throw new Error("The parameter 'pageNumber' cannot be null.");
else if (pageNumber !== undefined)
    url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
if (pageSize === null)
    throw new Error("The parameter 'pageSize' cannot be null.");
else if (pageSize !== undefined)
    url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
if (dateFrom === null)
    throw new Error("The parameter 'dateFrom' cannot be null.");
else if (dateFrom !== undefined)
    url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + Types.formatDate(dateFrom) : "") + "&";
if (dateTo === null)
    throw new Error("The parameter 'dateTo' cannot be null.");
else if (dateTo !== undefined)
    url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + Types.formatDate(dateTo) : "") + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let bookingsByCreationDateRangeGETDefaultOptions: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryFn'>> = {
};
export function getBookingsByCreationDateRangeGETDefaultOptions() {
  return bookingsByCreationDateRangeGETDefaultOptions;
};
export function setBookingsByCreationDateRangeGETDefaultOptions(options: typeof bookingsByCreationDateRangeGETDefaultOptions) {
  bookingsByCreationDateRangeGETDefaultOptions = options;
}

export function bookingsByCreationDateRangeGETQueryKey(dto: BookingsByCreationDateRangeGETQueryParameters): QueryKey;
export function bookingsByCreationDateRangeGETQueryKey(pageNumber?: number | undefined, pageSize?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined): QueryKey;
export function bookingsByCreationDateRangeGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { pageNumber, pageSize, dateFrom, dateTo,  } = params[0] as BookingsByCreationDateRangeGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'bookingsByCreationDateRangeGET',
        pageNumber as any,
        pageSize as any,
        dateFrom as any,
        dateTo as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'bookingsByCreationDateRangeGET',
        ...params
      ]);
  }
}
export function __bookingsByCreationDateRangeGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.bookingsByCreationDateRangeGET(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as Date | undefined,       context.queryKey[5] as Date | undefined,axiosConfig    );
}

export function useBookingsByCreationDateRangeGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(dto: BookingsByCreationDateRangeGETQueryParameters, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param dateFrom (optional) 
 * @param dateTo (optional) 
 * @return Success
 */
export function useBookingsByCreationDateRangeGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(pageNumber?: number | undefined, pageSize?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBookingsByCreationDateRangeGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let pageNumber: any = undefined;
  let pageSize: any = undefined;
  let dateFrom: any = undefined;
  let dateTo: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ pageNumber, pageSize, dateFrom, dateTo,  } = params[0] as BookingsByCreationDateRangeGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [pageNumber, pageSize, dateFrom, dateTo, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __bookingsByCreationDateRangeGET(context, axiosConfig) : __bookingsByCreationDateRangeGET,
    queryKey: bookingsByCreationDateRangeGETQueryKey(pageNumber, pageSize, dateFrom, dateTo),
    ...bookingsByCreationDateRangeGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param dateFrom (optional) 
 * @param dateTo (optional) 
 * @return Success
 */
export function setBookingsByCreationDateRangeGETData(queryClient: QueryClient, updater: (data: Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, pageNumber?: number | undefined, pageSize?: number | undefined, dateFrom?: Date | undefined, dateTo?: Date | undefined) {
  queryClient.setQueryData(bookingsByCreationDateRangeGETQueryKey(pageNumber, pageSize, dateFrom, dateTo),
    updater
  );
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param dateFrom (optional) 
 * @param dateTo (optional) 
 * @return Success
 */
export function setBookingsByCreationDateRangeGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetBookingsByCreationDateRangeQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function bookingsGuidGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/bookings/{guid}";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let bookingsGuidGETDefaultOptions: Omit<UseQueryOptions<Types.GetBookingQueryResult, unknown, Types.GetBookingQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetBookingQueryResult, unknown, Types.GetBookingQueryResult>, 'queryFn'>> = {
};
export function getBookingsGuidGETDefaultOptions() {
  return bookingsGuidGETDefaultOptions;
};
export function setBookingsGuidGETDefaultOptions(options: typeof bookingsGuidGETDefaultOptions) {
  bookingsGuidGETDefaultOptions = options;
}

export function bookingsGuidGETQueryKey(guid: string): QueryKey;
export function bookingsGuidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as BookingsGuidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'bookingsGuidGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'bookingsGuidGET',
        ...params
      ]);
  }
}
export function __bookingsGuidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.bookingsGuidGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function useBookingsGuidGETQuery<TSelectData = Types.GetBookingQueryResult, TError = unknown>(dto: BookingsGuidGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetBookingQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function useBookingsGuidGETQuery<TSelectData = Types.GetBookingQueryResult, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetBookingQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBookingsGuidGETQuery<TSelectData = Types.GetBookingQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetBookingQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as BookingsGuidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetBookingQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __bookingsGuidGET(context, axiosConfig) : __bookingsGuidGET,
    queryKey: bookingsGuidGETQueryKey(guid),
    ...bookingsGuidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetBookingQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setBookingsGuidGETData(queryClient: QueryClient, updater: (data: Types.GetBookingQueryResult | undefined) => Types.GetBookingQueryResult, guid: string) {
  queryClient.setQueryData(bookingsGuidGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setBookingsGuidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetBookingQueryResult | undefined) => Types.GetBookingQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function bookingsGuidCustomerGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/bookings/{guid}/customer";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let bookingsGuidCustomerGETDefaultOptions: Omit<UseQueryOptions<Types.GetBookingCustomerQueryResult, unknown, Types.GetBookingCustomerQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetBookingCustomerQueryResult, unknown, Types.GetBookingCustomerQueryResult>, 'queryFn'>> = {
};
export function getBookingsGuidCustomerGETDefaultOptions() {
  return bookingsGuidCustomerGETDefaultOptions;
};
export function setBookingsGuidCustomerGETDefaultOptions(options: typeof bookingsGuidCustomerGETDefaultOptions) {
  bookingsGuidCustomerGETDefaultOptions = options;
}

export function bookingsGuidCustomerGETQueryKey(guid: string): QueryKey;
export function bookingsGuidCustomerGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as BookingsGuidCustomerGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'bookingsGuidCustomerGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'bookingsGuidCustomerGET',
        ...params
      ]);
  }
}
export function __bookingsGuidCustomerGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.bookingsGuidCustomerGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function useBookingsGuidCustomerGETQuery<TSelectData = Types.GetBookingCustomerQueryResult, TError = unknown>(dto: BookingsGuidCustomerGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetBookingCustomerQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function useBookingsGuidCustomerGETQuery<TSelectData = Types.GetBookingCustomerQueryResult, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetBookingCustomerQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useBookingsGuidCustomerGETQuery<TSelectData = Types.GetBookingCustomerQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetBookingCustomerQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as BookingsGuidCustomerGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetBookingCustomerQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __bookingsGuidCustomerGET(context, axiosConfig) : __bookingsGuidCustomerGET,
    queryKey: bookingsGuidCustomerGETQueryKey(guid),
    ...bookingsGuidCustomerGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetBookingCustomerQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setBookingsGuidCustomerGETData(queryClient: QueryClient, updater: (data: Types.GetBookingCustomerQueryResult | undefined) => Types.GetBookingCustomerQueryResult, guid: string) {
  queryClient.setQueryData(bookingsGuidCustomerGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setBookingsGuidCustomerGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetBookingCustomerQueryResult | undefined) => Types.GetBookingCustomerQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function campaignsVisitPOSTUrl(): string {
  let url_ = getBaseUrl() + "/campaigns/visit";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function campaignsVisitPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'campaignsVisitPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return No Content
 */
export function useCampaignsVisitPOSTMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.AddCampaignVisitCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.AddCampaignVisitCommand, TContext> {
  const key = campaignsVisitPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.AddCampaignVisitCommand) => Client.campaignsVisitPOST(body),
    mutationKey: key,
  });
}
  
export function customersPOSTUrl(): string {
  let url_ = getBaseUrl() + "/customers";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function customersPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'customersPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function useCustomersPOSTMutation<TContext>(options?: Omit<UseMutationOptions<string, unknown, Types.GetOrCreateCustomerByEmailCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, Types.GetOrCreateCustomerByEmailCommand, TContext> {
  const key = customersPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.GetOrCreateCustomerByEmailCommand) => Client.customersPOST(body),
    mutationKey: key,
  });
}
  
export function customersCustomerguidWorldpayCustomerIdGETUrl(customerGuid: string): string {
  let url_ = getBaseUrl() + "/customers/{customerGuid}/worldpay-customer-id";
if (customerGuid === undefined || customerGuid === null)
  throw new Error("The parameter 'customerGuid' must be defined.");
url_ = url_.replace("{customerGuid}", encodeURIComponent("" + customerGuid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let customersCustomerguidWorldpayCustomerIdGETDefaultOptions: Omit<UseQueryOptions<Types.GetWorldPayCustomerIdQueryResult, unknown, Types.GetWorldPayCustomerIdQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetWorldPayCustomerIdQueryResult, unknown, Types.GetWorldPayCustomerIdQueryResult>, 'queryFn'>> = {
};
export function getCustomersCustomerguidWorldpayCustomerIdGETDefaultOptions() {
  return customersCustomerguidWorldpayCustomerIdGETDefaultOptions;
};
export function setCustomersCustomerguidWorldpayCustomerIdGETDefaultOptions(options: typeof customersCustomerguidWorldpayCustomerIdGETDefaultOptions) {
  customersCustomerguidWorldpayCustomerIdGETDefaultOptions = options;
}

export function customersCustomerguidWorldpayCustomerIdGETQueryKey(customerGuid: string): QueryKey;
export function customersCustomerguidWorldpayCustomerIdGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { customerGuid,  } = params[0] as CustomersCustomerguidWorldpayCustomerIdGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'customersCustomerguidWorldpayCustomerIdGET',
        customerGuid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'customersCustomerguidWorldpayCustomerIdGET',
        ...params
      ]);
  }
}
export function __customersCustomerguidWorldpayCustomerIdGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.customersCustomerguidWorldpayCustomerIdGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function useCustomersCustomerguidWorldpayCustomerIdGETQuery<TSelectData = Types.GetWorldPayCustomerIdQueryResult, TError = unknown>(dto: CustomersCustomerguidWorldpayCustomerIdGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetWorldPayCustomerIdQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function useCustomersCustomerguidWorldpayCustomerIdGETQuery<TSelectData = Types.GetWorldPayCustomerIdQueryResult, TError = unknown>(customerGuid: string, options?: Omit<UseQueryOptions<Types.GetWorldPayCustomerIdQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useCustomersCustomerguidWorldpayCustomerIdGETQuery<TSelectData = Types.GetWorldPayCustomerIdQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetWorldPayCustomerIdQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let customerGuid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ customerGuid,  } = params[0] as CustomersCustomerguidWorldpayCustomerIdGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [customerGuid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetWorldPayCustomerIdQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __customersCustomerguidWorldpayCustomerIdGET(context, axiosConfig) : __customersCustomerguidWorldpayCustomerIdGET,
    queryKey: customersCustomerguidWorldpayCustomerIdGETQueryKey(customerGuid),
    ...customersCustomerguidWorldpayCustomerIdGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetWorldPayCustomerIdQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setCustomersCustomerguidWorldpayCustomerIdGETData(queryClient: QueryClient, updater: (data: Types.GetWorldPayCustomerIdQueryResult | undefined) => Types.GetWorldPayCustomerIdQueryResult, customerGuid: string) {
  queryClient.setQueryData(customersCustomerguidWorldpayCustomerIdGETQueryKey(customerGuid),
    updater
  );
}

/**
 * @return Success
 */
export function setCustomersCustomerguidWorldpayCustomerIdGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetWorldPayCustomerIdQueryResult | undefined) => Types.GetWorldPayCustomerIdQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function formLeadsSubmitPOSTUrl(): string {
  let url_ = getBaseUrl() + "/form-leads/submit";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function formLeadsSubmitPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'formLeadsSubmitPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function useFormLeadsSubmitPOSTMutation<TContext>(options?: Omit<UseMutationOptions<string, unknown, Types.SubmitFormLeadCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, Types.SubmitFormLeadCommand, TContext> {
  const key = formLeadsSubmitPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.SubmitFormLeadCommand) => Client.formLeadsSubmitPOST(body),
    mutationKey: key,
  });
}
  
export function listingsGuidGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/listings/{guid}";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let listingsGuidGETDefaultOptions: Omit<UseQueryOptions<Types.GetMarketplaceListingQueryResult, unknown, Types.GetMarketplaceListingQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetMarketplaceListingQueryResult, unknown, Types.GetMarketplaceListingQueryResult>, 'queryFn'>> = {
};
export function getListingsGuidGETDefaultOptions() {
  return listingsGuidGETDefaultOptions;
};
export function setListingsGuidGETDefaultOptions(options: typeof listingsGuidGETDefaultOptions) {
  listingsGuidGETDefaultOptions = options;
}

export function listingsGuidGETQueryKey(guid: string): QueryKey;
export function listingsGuidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as ListingsGuidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'listingsGuidGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'listingsGuidGET',
        ...params
      ]);
  }
}
export function __listingsGuidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.listingsGuidGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function useListingsGuidGETQuery<TSelectData = Types.GetMarketplaceListingQueryResult, TError = unknown>(dto: ListingsGuidGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetMarketplaceListingQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function useListingsGuidGETQuery<TSelectData = Types.GetMarketplaceListingQueryResult, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetMarketplaceListingQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useListingsGuidGETQuery<TSelectData = Types.GetMarketplaceListingQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetMarketplaceListingQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as ListingsGuidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetMarketplaceListingQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __listingsGuidGET(context, axiosConfig) : __listingsGuidGET,
    queryKey: listingsGuidGETQueryKey(guid),
    ...listingsGuidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetMarketplaceListingQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setListingsGuidGETData(queryClient: QueryClient, updater: (data: Types.GetMarketplaceListingQueryResult | undefined) => Types.GetMarketplaceListingQueryResult, guid: string) {
  queryClient.setQueryData(listingsGuidGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setListingsGuidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetMarketplaceListingQueryResult | undefined) => Types.GetMarketplaceListingQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function listingsGuidCalendarDaysGETUrl(guid: string, from?: Date | undefined, to?: Date | undefined): string {
  let url_ = getBaseUrl() + "/listings/{guid}/calendar-days?";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
if (from === null)
    throw new Error("The parameter 'from' cannot be null.");
else if (from !== undefined)
    url_ += "from=" + encodeURIComponent(from ? "" + Types.formatDate(from) : "") + "&";
if (to === null)
    throw new Error("The parameter 'to' cannot be null.");
else if (to !== undefined)
    url_ += "to=" + encodeURIComponent(to ? "" + Types.formatDate(to) : "") + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let listingsGuidCalendarDaysGETDefaultOptions: Omit<UseQueryOptions<Types.GetMarketplaceCalendarDaysQueryResult[], unknown, Types.GetMarketplaceCalendarDaysQueryResult[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetMarketplaceCalendarDaysQueryResult[], unknown, Types.GetMarketplaceCalendarDaysQueryResult[]>, 'queryFn'>> = {
};
export function getListingsGuidCalendarDaysGETDefaultOptions() {
  return listingsGuidCalendarDaysGETDefaultOptions;
};
export function setListingsGuidCalendarDaysGETDefaultOptions(options: typeof listingsGuidCalendarDaysGETDefaultOptions) {
  listingsGuidCalendarDaysGETDefaultOptions = options;
}

export function listingsGuidCalendarDaysGETQueryKey(dto: ListingsGuidCalendarDaysGETQueryParameters): QueryKey;
export function listingsGuidCalendarDaysGETQueryKey(guid: string, from?: Date | undefined, to?: Date | undefined): QueryKey;
export function listingsGuidCalendarDaysGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid, from, to,  } = params[0] as ListingsGuidCalendarDaysGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'listingsGuidCalendarDaysGET',
        guid as any,
        from as any,
        to as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'listingsGuidCalendarDaysGET',
        ...params
      ]);
  }
}
export function __listingsGuidCalendarDaysGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.listingsGuidCalendarDaysGET(
      context.queryKey[2] as string,       context.queryKey[3] as Date | undefined,       context.queryKey[4] as Date | undefined,axiosConfig    );
}

export function useListingsGuidCalendarDaysGETQuery<TSelectData = Types.GetMarketplaceCalendarDaysQueryResult[], TError = unknown>(dto: ListingsGuidCalendarDaysGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetMarketplaceCalendarDaysQueryResult[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param from (optional) 
 * @param to (optional) 
 * @return Success
 */
export function useListingsGuidCalendarDaysGETQuery<TSelectData = Types.GetMarketplaceCalendarDaysQueryResult[], TError = unknown>(guid: string, from?: Date | undefined, to?: Date | undefined, options?: Omit<UseQueryOptions<Types.GetMarketplaceCalendarDaysQueryResult[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useListingsGuidCalendarDaysGETQuery<TSelectData = Types.GetMarketplaceCalendarDaysQueryResult[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetMarketplaceCalendarDaysQueryResult[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  let from: any = undefined;
  let to: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid, from, to,  } = params[0] as ListingsGuidCalendarDaysGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, from, to, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetMarketplaceCalendarDaysQueryResult[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __listingsGuidCalendarDaysGET(context, axiosConfig) : __listingsGuidCalendarDaysGET,
    queryKey: listingsGuidCalendarDaysGETQueryKey(guid, from, to),
    ...listingsGuidCalendarDaysGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetMarketplaceCalendarDaysQueryResult[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param from (optional) 
 * @param to (optional) 
 * @return Success
 */
export function setListingsGuidCalendarDaysGETData(queryClient: QueryClient, updater: (data: Types.GetMarketplaceCalendarDaysQueryResult[] | undefined) => Types.GetMarketplaceCalendarDaysQueryResult[], guid: string, from?: Date | undefined, to?: Date | undefined) {
  queryClient.setQueryData(listingsGuidCalendarDaysGETQueryKey(guid, from, to),
    updater
  );
}

/**
 * @param from (optional) 
 * @param to (optional) 
 * @return Success
 */
export function setListingsGuidCalendarDaysGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetMarketplaceCalendarDaysQueryResult[] | undefined) => Types.GetMarketplaceCalendarDaysQueryResult[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function listingsAvailablePOSTUrl(): string {
  let url_ = getBaseUrl() + "/listings/available";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function listingsAvailablePOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'listingsAvailablePOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function useListingsAvailablePOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.GetMarketplaceAvailableListingQueryResult, unknown, Types.GetMarketplaceAvailableListingQuery, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.GetMarketplaceAvailableListingQueryResult, unknown, Types.GetMarketplaceAvailableListingQuery, TContext> {
  const key = listingsAvailablePOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.GetMarketplaceAvailableListingQuery) => Client.listingsAvailablePOST(body),
    mutationKey: key,
  });
}
  
export function listingsGuidCalendarDayPricingsGETUrl(guid: string, date?: Date | undefined): string {
  let url_ = getBaseUrl() + "/listings/{guid}/calendar-day-pricings?";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
if (date === null)
    throw new Error("The parameter 'date' cannot be null.");
else if (date !== undefined)
    url_ += "date=" + encodeURIComponent(date ? "" + Types.formatDate(date) : "") + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let listingsGuidCalendarDayPricingsGETDefaultOptions: Omit<UseQueryOptions<Types.GetMarketplaceCalendarDayPricingsQueryResult, unknown, Types.GetMarketplaceCalendarDayPricingsQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetMarketplaceCalendarDayPricingsQueryResult, unknown, Types.GetMarketplaceCalendarDayPricingsQueryResult>, 'queryFn'>> = {
};
export function getListingsGuidCalendarDayPricingsGETDefaultOptions() {
  return listingsGuidCalendarDayPricingsGETDefaultOptions;
};
export function setListingsGuidCalendarDayPricingsGETDefaultOptions(options: typeof listingsGuidCalendarDayPricingsGETDefaultOptions) {
  listingsGuidCalendarDayPricingsGETDefaultOptions = options;
}

export function listingsGuidCalendarDayPricingsGETQueryKey(dto: ListingsGuidCalendarDayPricingsGETQueryParameters): QueryKey;
export function listingsGuidCalendarDayPricingsGETQueryKey(guid: string, date?: Date | undefined): QueryKey;
export function listingsGuidCalendarDayPricingsGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid, date,  } = params[0] as ListingsGuidCalendarDayPricingsGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'listingsGuidCalendarDayPricingsGET',
        guid as any,
        date as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'listingsGuidCalendarDayPricingsGET',
        ...params
      ]);
  }
}
export function __listingsGuidCalendarDayPricingsGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.listingsGuidCalendarDayPricingsGET(
      context.queryKey[2] as string,       context.queryKey[3] as Date | undefined,axiosConfig    );
}

export function useListingsGuidCalendarDayPricingsGETQuery<TSelectData = Types.GetMarketplaceCalendarDayPricingsQueryResult, TError = unknown>(dto: ListingsGuidCalendarDayPricingsGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetMarketplaceCalendarDayPricingsQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param date (optional) 
 * @return Success
 */
export function useListingsGuidCalendarDayPricingsGETQuery<TSelectData = Types.GetMarketplaceCalendarDayPricingsQueryResult, TError = unknown>(guid: string, date?: Date | undefined, options?: Omit<UseQueryOptions<Types.GetMarketplaceCalendarDayPricingsQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useListingsGuidCalendarDayPricingsGETQuery<TSelectData = Types.GetMarketplaceCalendarDayPricingsQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetMarketplaceCalendarDayPricingsQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  let date: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid, date,  } = params[0] as ListingsGuidCalendarDayPricingsGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, date, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetMarketplaceCalendarDayPricingsQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __listingsGuidCalendarDayPricingsGET(context, axiosConfig) : __listingsGuidCalendarDayPricingsGET,
    queryKey: listingsGuidCalendarDayPricingsGETQueryKey(guid, date),
    ...listingsGuidCalendarDayPricingsGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetMarketplaceCalendarDayPricingsQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param date (optional) 
 * @return Success
 */
export function setListingsGuidCalendarDayPricingsGETData(queryClient: QueryClient, updater: (data: Types.GetMarketplaceCalendarDayPricingsQueryResult | undefined) => Types.GetMarketplaceCalendarDayPricingsQueryResult, guid: string, date?: Date | undefined) {
  queryClient.setQueryData(listingsGuidCalendarDayPricingsGETQueryKey(guid, date),
    updater
  );
}

/**
 * @param date (optional) 
 * @return Success
 */
export function setListingsGuidCalendarDayPricingsGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetMarketplaceCalendarDayPricingsQueryResult | undefined) => Types.GetMarketplaceCalendarDayPricingsQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function listingsAvailableListingsDetailsGETUrl(pageNumber?: number | undefined, pageSize?: number | undefined, date?: Date | undefined, marketTitle?: string | undefined, boatGuids?: string[] | undefined): string {
  let url_ = getBaseUrl() + "/listings/available-listings-details?";
if (pageNumber === null)
    throw new Error("The parameter 'pageNumber' cannot be null.");
else if (pageNumber !== undefined)
    url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
if (pageSize === null)
    throw new Error("The parameter 'pageSize' cannot be null.");
else if (pageSize !== undefined)
    url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
if (date === null)
    throw new Error("The parameter 'date' cannot be null.");
else if (date !== undefined)
    url_ += "Date=" + encodeURIComponent(date ? "" + Types.formatDate(date) : "") + "&";
if (marketTitle === null)
    throw new Error("The parameter 'marketTitle' cannot be null.");
else if (marketTitle !== undefined)
    url_ += "MarketTitle=" + encodeURIComponent("" + marketTitle) + "&";
if (boatGuids === null)
    throw new Error("The parameter 'boatGuids' cannot be null.");
else if (boatGuids !== undefined)
    boatGuids && boatGuids.forEach(item => { url_ += "BoatGuids=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let listingsAvailableListingsDetailsGETDefaultOptions: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, unknown, Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null>, 'queryFn'>> = {
};
export function getListingsAvailableListingsDetailsGETDefaultOptions() {
  return listingsAvailableListingsDetailsGETDefaultOptions;
};
export function setListingsAvailableListingsDetailsGETDefaultOptions(options: typeof listingsAvailableListingsDetailsGETDefaultOptions) {
  listingsAvailableListingsDetailsGETDefaultOptions = options;
}

export function listingsAvailableListingsDetailsGETQueryKey(dto: ListingsAvailableListingsDetailsGETQueryParameters): QueryKey;
export function listingsAvailableListingsDetailsGETQueryKey(pageNumber?: number | undefined, pageSize?: number | undefined, date?: Date | undefined, marketTitle?: string | undefined, boatGuids?: string[] | undefined): QueryKey;
export function listingsAvailableListingsDetailsGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { pageNumber, pageSize, date, marketTitle, boatGuids,  } = params[0] as ListingsAvailableListingsDetailsGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'listingsAvailableListingsDetailsGET',
        pageNumber as any,
        pageSize as any,
        date as any,
        marketTitle as any,
        boatGuids as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'listingsAvailableListingsDetailsGET',
        ...params
      ]);
  }
}
export function __listingsAvailableListingsDetailsGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.listingsAvailableListingsDetailsGET(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as Date | undefined,       context.queryKey[5] as string | undefined,       context.queryKey[6] as string[] | undefined,axiosConfig    );
}

export function useListingsAvailableListingsDetailsGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(dto: ListingsAvailableListingsDetailsGETQueryParameters, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param date (optional) 
 * @param marketTitle (optional) 
 * @param boatGuids (optional) 
 * @return Success
 */
export function useListingsAvailableListingsDetailsGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(pageNumber?: number | undefined, pageSize?: number | undefined, date?: Date | undefined, marketTitle?: string | undefined, boatGuids?: string[] | undefined, options?: Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useListingsAvailableListingsDetailsGETQuery<TSelectData = Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let pageNumber: any = undefined;
  let pageSize: any = undefined;
  let date: any = undefined;
  let marketTitle: any = undefined;
  let boatGuids: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ pageNumber, pageSize, date, marketTitle, boatGuids,  } = params[0] as ListingsAvailableListingsDetailsGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [pageNumber, pageSize, date, marketTitle, boatGuids, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __listingsAvailableListingsDetailsGET(context, axiosConfig) : __listingsAvailableListingsDetailsGET,
    queryKey: listingsAvailableListingsDetailsGETQueryKey(pageNumber, pageSize, date, marketTitle, boatGuids),
    ...listingsAvailableListingsDetailsGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param date (optional) 
 * @param marketTitle (optional) 
 * @param boatGuids (optional) 
 * @return Success
 */
export function setListingsAvailableListingsDetailsGETData(queryClient: QueryClient, updater: (data: Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null, pageNumber?: number | undefined, pageSize?: number | undefined, date?: Date | undefined, marketTitle?: string | undefined, boatGuids?: string[] | undefined) {
  queryClient.setQueryData(listingsAvailableListingsDetailsGETQueryKey(pageNumber, pageSize, date, marketTitle, boatGuids),
    updater
  );
}

/**
 * @param pageNumber (optional) 
 * @param pageSize (optional) 
 * @param date (optional) 
 * @param marketTitle (optional) 
 * @param boatGuids (optional) 
 * @return Success
 */
export function setListingsAvailableListingsDetailsGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null | undefined) => Types.PaginatedResult_1OfOfGetAvailableListingsQueryResultAndApplicationAnd_0AndCulture_neutralAndPublicKeyToken_null) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function ownersGuidGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/owners/{guid}";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let ownersGuidGETDefaultOptions: Omit<UseQueryOptions<Types.GetOwnerQueryResult, unknown, Types.GetOwnerQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetOwnerQueryResult, unknown, Types.GetOwnerQueryResult>, 'queryFn'>> = {
};
export function getOwnersGuidGETDefaultOptions() {
  return ownersGuidGETDefaultOptions;
};
export function setOwnersGuidGETDefaultOptions(options: typeof ownersGuidGETDefaultOptions) {
  ownersGuidGETDefaultOptions = options;
}

export function ownersGuidGETQueryKey(guid: string): QueryKey;
export function ownersGuidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as OwnersGuidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'ownersGuidGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'ownersGuidGET',
        ...params
      ]);
  }
}
export function __ownersGuidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.ownersGuidGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function useOwnersGuidGETQuery<TSelectData = Types.GetOwnerQueryResult, TError = unknown>(dto: OwnersGuidGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetOwnerQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function useOwnersGuidGETQuery<TSelectData = Types.GetOwnerQueryResult, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetOwnerQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useOwnersGuidGETQuery<TSelectData = Types.GetOwnerQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetOwnerQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as OwnersGuidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetOwnerQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __ownersGuidGET(context, axiosConfig) : __ownersGuidGET,
    queryKey: ownersGuidGETQueryKey(guid),
    ...ownersGuidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetOwnerQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setOwnersGuidGETData(queryClient: QueryClient, updater: (data: Types.GetOwnerQueryResult | undefined) => Types.GetOwnerQueryResult, guid: string) {
  queryClient.setQueryData(ownersGuidGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setOwnersGuidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetOwnerQueryResult | undefined) => Types.GetOwnerQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function paymentsCreatePaymentIntentPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/create-payment-intent";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsCreatePaymentIntentPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsCreatePaymentIntentPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 * @deprecated
 */
export function usePaymentsCreatePaymentIntentPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.CreatePaymentIntentCommandResult, unknown, Types.CreateBookingPaymentIntentCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CreatePaymentIntentCommandResult, unknown, Types.CreateBookingPaymentIntentCommand, TContext> {
  const key = paymentsCreatePaymentIntentPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.CreateBookingPaymentIntentCommand) => Client.paymentsCreatePaymentIntentPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsAuthorize_NetCreatePaymentPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/authorize.net/create-payment";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsAuthorize_NetCreatePaymentPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsAuthorize_NetCreatePaymentPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsAuthorize_NetCreatePaymentPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.ChargeBookingAuthorizeNetPaymentCommandResult, unknown, Types.ChargeBookingAuthorizeNetPaymentCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ChargeBookingAuthorizeNetPaymentCommandResult, unknown, Types.ChargeBookingAuthorizeNetPaymentCommand, TContext> {
  const key = paymentsAuthorize_NetCreatePaymentPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ChargeBookingAuthorizeNetPaymentCommand) => Client.paymentsAuthorize_NetCreatePaymentPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsAuthorize_NetCheckoutSessionPaymentProcessPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/authorize.net/checkout-session-payment/process";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsAuthorize_NetCheckoutSessionPaymentProcessPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsAuthorize_NetCheckoutSessionPaymentProcessPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsAuthorize_NetCheckoutSessionPaymentProcessPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.ProcessAuthorizeNetCheckoutSessionPaymentCommandResult, unknown, Types.ProcessAuthorizeNetCheckoutSessionPaymentCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProcessAuthorizeNetCheckoutSessionPaymentCommandResult, unknown, Types.ProcessAuthorizeNetCheckoutSessionPaymentCommand, TContext> {
  const key = paymentsAuthorize_NetCheckoutSessionPaymentProcessPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ProcessAuthorizeNetCheckoutSessionPaymentCommand) => Client.paymentsAuthorize_NetCheckoutSessionPaymentProcessPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsGuidGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/payments/{guid}";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let paymentsGuidGETDefaultOptions: Omit<UseQueryOptions<Types.GetPaymentQueryResult, unknown, Types.GetPaymentQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetPaymentQueryResult, unknown, Types.GetPaymentQueryResult>, 'queryFn'>> = {
};
export function getPaymentsGuidGETDefaultOptions() {
  return paymentsGuidGETDefaultOptions;
};
export function setPaymentsGuidGETDefaultOptions(options: typeof paymentsGuidGETDefaultOptions) {
  paymentsGuidGETDefaultOptions = options;
}

export function paymentsGuidGETQueryKey(guid: string): QueryKey;
export function paymentsGuidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as PaymentsGuidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'paymentsGuidGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'paymentsGuidGET',
        ...params
      ]);
  }
}
export function __paymentsGuidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.paymentsGuidGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function usePaymentsGuidGETQuery<TSelectData = Types.GetPaymentQueryResult, TError = unknown>(dto: PaymentsGuidGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetPaymentQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function usePaymentsGuidGETQuery<TSelectData = Types.GetPaymentQueryResult, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetPaymentQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePaymentsGuidGETQuery<TSelectData = Types.GetPaymentQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetPaymentQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as PaymentsGuidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetPaymentQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __paymentsGuidGET(context, axiosConfig) : __paymentsGuidGET,
    queryKey: paymentsGuidGETQueryKey(guid),
    ...paymentsGuidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetPaymentQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setPaymentsGuidGETData(queryClient: QueryClient, updater: (data: Types.GetPaymentQueryResult | undefined) => Types.GetPaymentQueryResult, guid: string) {
  queryClient.setQueryData(paymentsGuidGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setPaymentsGuidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetPaymentQueryResult | undefined) => Types.GetPaymentQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function paymentsCreatePaymentSessionPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/create-payment-session";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsCreatePaymentSessionPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsCreatePaymentSessionPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsCreatePaymentSessionPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.CreateStripeCheckoutSessionCommandResult, unknown, Types.CreateBookingStripeCheckoutSessionCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CreateStripeCheckoutSessionCommandResult, unknown, Types.CreateBookingStripeCheckoutSessionCommand, TContext> {
  const key = paymentsCreatePaymentSessionPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.CreateBookingStripeCheckoutSessionCommand) => Client.paymentsCreatePaymentSessionPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsCustomerDashboardCreatePaymentSessionPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/customer-dashboard/create-payment-session";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsCustomerDashboardCreatePaymentSessionPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsCustomerDashboardCreatePaymentSessionPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsCustomerDashboardCreatePaymentSessionPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult, unknown, Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommandResult, unknown, Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommand, TContext> {
  const key = paymentsCustomerDashboardCreatePaymentSessionPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.CreateCustomerDashboardBookingStripeCheckoutSessionCommand) => Client.paymentsCustomerDashboardCreatePaymentSessionPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsAuthorize_NetCheckoutSessionPaymentPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/authorize.net/checkout-session-payment";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsAuthorize_NetCheckoutSessionPaymentPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsAuthorize_NetCheckoutSessionPaymentPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsAuthorize_NetCheckoutSessionPaymentPOSTMutation<TContext>(options?: Omit<UseMutationOptions<string, unknown, Types.CreateBookingAuthorizeNetCheckoutSessionCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, Types.CreateBookingAuthorizeNetCheckoutSessionCommand, TContext> {
  const key = paymentsAuthorize_NetCheckoutSessionPaymentPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.CreateBookingAuthorizeNetCheckoutSessionCommand) => Client.paymentsAuthorize_NetCheckoutSessionPaymentPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsAuthorize_NetCheckoutSessionGuidGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/payments/authorize.net/checkout-session/{guid}";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let paymentsAuthorize_NetCheckoutSessionGuidGETDefaultOptions: Omit<UseQueryOptions<Types.GetAuthorizeNetCheckoutSessionQueryResponse, unknown, Types.GetAuthorizeNetCheckoutSessionQueryResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetAuthorizeNetCheckoutSessionQueryResponse, unknown, Types.GetAuthorizeNetCheckoutSessionQueryResponse>, 'queryFn'>> = {
};
export function getPaymentsAuthorize_NetCheckoutSessionGuidGETDefaultOptions() {
  return paymentsAuthorize_NetCheckoutSessionGuidGETDefaultOptions;
};
export function setPaymentsAuthorize_NetCheckoutSessionGuidGETDefaultOptions(options: typeof paymentsAuthorize_NetCheckoutSessionGuidGETDefaultOptions) {
  paymentsAuthorize_NetCheckoutSessionGuidGETDefaultOptions = options;
}

export function paymentsAuthorize_NetCheckoutSessionGuidGETQueryKey(guid: string): QueryKey;
export function paymentsAuthorize_NetCheckoutSessionGuidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as PaymentsAuthorize_NetCheckoutSessionGuidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'paymentsAuthorize_NetCheckoutSessionGuidGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'paymentsAuthorize_NetCheckoutSessionGuidGET',
        ...params
      ]);
  }
}
export function __paymentsAuthorize_NetCheckoutSessionGuidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.paymentsAuthorize_NetCheckoutSessionGuidGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function usePaymentsAuthorize_NetCheckoutSessionGuidGETQuery<TSelectData = Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError = unknown>(dto: PaymentsAuthorize_NetCheckoutSessionGuidGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function usePaymentsAuthorize_NetCheckoutSessionGuidGETQuery<TSelectData = Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePaymentsAuthorize_NetCheckoutSessionGuidGETQuery<TSelectData = Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as PaymentsAuthorize_NetCheckoutSessionGuidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __paymentsAuthorize_NetCheckoutSessionGuidGET(context, axiosConfig) : __paymentsAuthorize_NetCheckoutSessionGuidGET,
    queryKey: paymentsAuthorize_NetCheckoutSessionGuidGETQueryKey(guid),
    ...paymentsAuthorize_NetCheckoutSessionGuidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetAuthorizeNetCheckoutSessionQueryResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setPaymentsAuthorize_NetCheckoutSessionGuidGETData(queryClient: QueryClient, updater: (data: Types.GetAuthorizeNetCheckoutSessionQueryResponse | undefined) => Types.GetAuthorizeNetCheckoutSessionQueryResponse, guid: string) {
  queryClient.setQueryData(paymentsAuthorize_NetCheckoutSessionGuidGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setPaymentsAuthorize_NetCheckoutSessionGuidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetAuthorizeNetCheckoutSessionQueryResponse | undefined) => Types.GetAuthorizeNetCheckoutSessionQueryResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function paymentsStatusGETUrl(guid?: string | undefined): string {
  let url_ = getBaseUrl() + "/payments/status?";
if (guid === null)
    throw new Error("The parameter 'guid' cannot be null.");
else if (guid !== undefined)
    url_ += "Guid=" + encodeURIComponent("" + guid) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let paymentsStatusGETDefaultOptions: Omit<UseQueryOptions<Types.GetPaymentStatusQueryResult, unknown, Types.GetPaymentStatusQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetPaymentStatusQueryResult, unknown, Types.GetPaymentStatusQueryResult>, 'queryFn'>> = {
};
export function getPaymentsStatusGETDefaultOptions() {
  return paymentsStatusGETDefaultOptions;
};
export function setPaymentsStatusGETDefaultOptions(options: typeof paymentsStatusGETDefaultOptions) {
  paymentsStatusGETDefaultOptions = options;
}

export function paymentsStatusGETQueryKey(guid?: string | undefined): QueryKey;
export function paymentsStatusGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as PaymentsStatusGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'paymentsStatusGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'paymentsStatusGET',
        ...params
      ]);
  }
}
export function __paymentsStatusGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.paymentsStatusGET(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function usePaymentsStatusGETQuery<TSelectData = Types.GetPaymentStatusQueryResult, TError = unknown>(dto: PaymentsStatusGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetPaymentStatusQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param guid (optional) 
 * @return Success
 */
export function usePaymentsStatusGETQuery<TSelectData = Types.GetPaymentStatusQueryResult, TError = unknown>(guid?: string | undefined, options?: Omit<UseQueryOptions<Types.GetPaymentStatusQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePaymentsStatusGETQuery<TSelectData = Types.GetPaymentStatusQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetPaymentStatusQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as PaymentsStatusGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetPaymentStatusQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __paymentsStatusGET(context, axiosConfig) : __paymentsStatusGET,
    queryKey: paymentsStatusGETQueryKey(guid),
    ...paymentsStatusGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetPaymentStatusQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param guid (optional) 
 * @return Success
 */
export function setPaymentsStatusGETData(queryClient: QueryClient, updater: (data: Types.GetPaymentStatusQueryResult | undefined) => Types.GetPaymentStatusQueryResult, guid?: string | undefined) {
  queryClient.setQueryData(paymentsStatusGETQueryKey(guid),
    updater
  );
}

/**
 * @param guid (optional) 
 * @return Success
 */
export function setPaymentsStatusGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetPaymentStatusQueryResult | undefined) => Types.GetPaymentStatusQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function paymentsWorldpayCheckoutSessionPaymentPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/worldpay/checkout-session-payment";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsWorldpayCheckoutSessionPaymentPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsWorldpayCheckoutSessionPaymentPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsWorldpayCheckoutSessionPaymentPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.CreateBookingWorldPayCheckoutSessionCommandResult, unknown, Types.CreateBookingWorldPayCheckoutSessionCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CreateBookingWorldPayCheckoutSessionCommandResult, unknown, Types.CreateBookingWorldPayCheckoutSessionCommand, TContext> {
  const key = paymentsWorldpayCheckoutSessionPaymentPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.CreateBookingWorldPayCheckoutSessionCommand) => Client.paymentsWorldpayCheckoutSessionPaymentPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsWorldpayCheckoutSessionPaymentProcessPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/worldpay/checkout-session-payment/process";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsWorldpayCheckoutSessionPaymentProcessPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsWorldpayCheckoutSessionPaymentProcessPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsWorldpayCheckoutSessionPaymentProcessPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.ProcessWorldPayCheckoutSessionPaymentCommandResult, unknown, Types.ProcessWorldPayCheckoutSessionPaymentCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProcessWorldPayCheckoutSessionPaymentCommandResult, unknown, Types.ProcessWorldPayCheckoutSessionPaymentCommand, TContext> {
  const key = paymentsWorldpayCheckoutSessionPaymentProcessPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ProcessWorldPayCheckoutSessionPaymentCommand) => Client.paymentsWorldpayCheckoutSessionPaymentProcessPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsWorldpayCheckoutSessionGuidGETUrl(guid: string): string {
  let url_ = getBaseUrl() + "/payments/worldpay/checkout-session/{guid}";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let paymentsWorldpayCheckoutSessionGuidGETDefaultOptions: Omit<UseQueryOptions<Types.GetWorldPayCheckoutSessionQueryResponse, unknown, Types.GetWorldPayCheckoutSessionQueryResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetWorldPayCheckoutSessionQueryResponse, unknown, Types.GetWorldPayCheckoutSessionQueryResponse>, 'queryFn'>> = {
};
export function getPaymentsWorldpayCheckoutSessionGuidGETDefaultOptions() {
  return paymentsWorldpayCheckoutSessionGuidGETDefaultOptions;
};
export function setPaymentsWorldpayCheckoutSessionGuidGETDefaultOptions(options: typeof paymentsWorldpayCheckoutSessionGuidGETDefaultOptions) {
  paymentsWorldpayCheckoutSessionGuidGETDefaultOptions = options;
}

export function paymentsWorldpayCheckoutSessionGuidGETQueryKey(guid: string): QueryKey;
export function paymentsWorldpayCheckoutSessionGuidGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { guid,  } = params[0] as PaymentsWorldpayCheckoutSessionGuidGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'paymentsWorldpayCheckoutSessionGuidGET',
        guid as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'paymentsWorldpayCheckoutSessionGuidGET',
        ...params
      ]);
  }
}
export function __paymentsWorldpayCheckoutSessionGuidGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.paymentsWorldpayCheckoutSessionGuidGET(
      context.queryKey[2] as string,axiosConfig    );
}

export function usePaymentsWorldpayCheckoutSessionGuidGETQuery<TSelectData = Types.GetWorldPayCheckoutSessionQueryResponse, TError = unknown>(dto: PaymentsWorldpayCheckoutSessionGuidGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetWorldPayCheckoutSessionQueryResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return Success
 */
export function usePaymentsWorldpayCheckoutSessionGuidGETQuery<TSelectData = Types.GetWorldPayCheckoutSessionQueryResponse, TError = unknown>(guid: string, options?: Omit<UseQueryOptions<Types.GetWorldPayCheckoutSessionQueryResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePaymentsWorldpayCheckoutSessionGuidGETQuery<TSelectData = Types.GetWorldPayCheckoutSessionQueryResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetWorldPayCheckoutSessionQueryResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let guid: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ guid,  } = params[0] as PaymentsWorldpayCheckoutSessionGuidGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [guid, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetWorldPayCheckoutSessionQueryResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __paymentsWorldpayCheckoutSessionGuidGET(context, axiosConfig) : __paymentsWorldpayCheckoutSessionGuidGET,
    queryKey: paymentsWorldpayCheckoutSessionGuidGETQueryKey(guid),
    ...paymentsWorldpayCheckoutSessionGuidGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetWorldPayCheckoutSessionQueryResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setPaymentsWorldpayCheckoutSessionGuidGETData(queryClient: QueryClient, updater: (data: Types.GetWorldPayCheckoutSessionQueryResponse | undefined) => Types.GetWorldPayCheckoutSessionQueryResponse, guid: string) {
  queryClient.setQueryData(paymentsWorldpayCheckoutSessionGuidGETQueryKey(guid),
    updater
  );
}

/**
 * @return Success
 */
export function setPaymentsWorldpayCheckoutSessionGuidGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetWorldPayCheckoutSessionQueryResponse | undefined) => Types.GetWorldPayCheckoutSessionQueryResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function paymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOSTUrl(): string {
  let url_ = getBaseUrl() + "/payments/customer-dashboard/worldpay/checkout-session-payment";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOSTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST',
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePaymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOSTMutation<TContext>(options?: Omit<UseMutationOptions<Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult, unknown, Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommandResult, unknown, Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommand, TContext> {
  const key = paymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOSTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.CreateCustomerDashboardBookingWorldPayCheckoutSessionCommand) => Client.paymentsCustomerDashboardWorldpayCheckoutSessionPaymentPOST(body),
    mutationKey: key,
  });
}
  
export function paymentsIntent__DebugPOSTUrl(paymentIntentId?: string | undefined, paymentIntentEventType?: string | undefined): string {
  let url_ = getBaseUrl() + "/payments/intent__debug?";
if (paymentIntentId === null)
    throw new Error("The parameter 'paymentIntentId' cannot be null.");
else if (paymentIntentId !== undefined)
    url_ += "paymentIntentId=" + encodeURIComponent("" + paymentIntentId) + "&";
if (paymentIntentEventType === null)
    throw new Error("The parameter 'paymentIntentEventType' cannot be null.");
else if (paymentIntentEventType !== undefined)
    url_ += "paymentIntentEventType=" + encodeURIComponent("" + paymentIntentEventType) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsIntent__DebugPOSTMutationKey(paymentIntentId?: string | undefined, paymentIntentEventType?: string | undefined): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsIntent__DebugPOST',
      paymentIntentId as any,
      paymentIntentEventType as any,
    ]);
}

export function usePaymentsIntent__DebugPOSTMutation<TContext>(paymentIntentId?: string | undefined, paymentIntentEventType?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = paymentsIntent__DebugPOSTMutationKey(paymentIntentId, paymentIntentEventType);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.paymentsIntent__DebugPOST(paymentIntentId, paymentIntentEventType),
    mutationKey: key,
  });
}
  
type PaymentsIntent__DebugPOST__MutationParameters = PaymentsIntent__DebugPOSTQueryParameters

export function usePaymentsIntent__DebugPOSTMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PaymentsIntent__DebugPOST__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PaymentsIntent__DebugPOSTQueryParameters}): UseMutationResult<void, unknown, PaymentsIntent__DebugPOST__MutationParameters, TContext> {
  const key = paymentsIntent__DebugPOSTMutationKey(options?.parameters?.paymentIntentId!, options?.parameters?.paymentIntentEventType!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PaymentsIntent__DebugPOST__MutationParameters) => Client.paymentsIntent__DebugPOST(data.paymentIntentId ?? options?.parameters?.paymentIntentId!, data.paymentIntentEventType ?? options?.parameters?.paymentIntentEventType!),
  mutationKey: key,
});
}
  
export function paymentsCheckoutSession__DebugPOSTUrl(sessionId?: string | undefined, amountTotal?: number | undefined): string {
  let url_ = getBaseUrl() + "/payments/checkout-session__debug?";
if (sessionId === null)
    throw new Error("The parameter 'sessionId' cannot be null.");
else if (sessionId !== undefined)
    url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
if (amountTotal === null)
    throw new Error("The parameter 'amountTotal' cannot be null.");
else if (amountTotal !== undefined)
    url_ += "amountTotal=" + encodeURIComponent("" + amountTotal) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function paymentsCheckoutSession__DebugPOSTMutationKey(sessionId?: string | undefined, amountTotal?: number | undefined): MutationKey {
  return trimArrayEnd([
      'Client',
      'paymentsCheckoutSession__DebugPOST',
      sessionId as any,
      amountTotal as any,
    ]);
}

export function usePaymentsCheckoutSession__DebugPOSTMutation<TContext>(sessionId?: string | undefined, amountTotal?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = paymentsCheckoutSession__DebugPOSTMutationKey(sessionId, amountTotal);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.paymentsCheckoutSession__DebugPOST(sessionId, amountTotal),
    mutationKey: key,
  });
}
  
type PaymentsCheckoutSession__DebugPOST__MutationParameters = PaymentsCheckoutSession__DebugPOSTQueryParameters

export function usePaymentsCheckoutSession__DebugPOSTMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PaymentsCheckoutSession__DebugPOST__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PaymentsCheckoutSession__DebugPOSTQueryParameters}): UseMutationResult<void, unknown, PaymentsCheckoutSession__DebugPOST__MutationParameters, TContext> {
  const key = paymentsCheckoutSession__DebugPOSTMutationKey(options?.parameters?.sessionId!, options?.parameters?.amountTotal!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PaymentsCheckoutSession__DebugPOST__MutationParameters) => Client.paymentsCheckoutSession__DebugPOST(data.sessionId ?? options?.parameters?.sessionId!, data.amountTotal ?? options?.parameters?.amountTotal!),
  mutationKey: key,
});
}
  
export function platformAccountPaymentGatewayGETUrl(): string {
  let url_ = getBaseUrl() + "/platform-account/payment-gateway";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let platformAccountPaymentGatewayGETDefaultOptions: Omit<UseQueryOptions<Types.GetPlatformAccountPaymentGatewayQueryResult, unknown, Types.GetPlatformAccountPaymentGatewayQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetPlatformAccountPaymentGatewayQueryResult, unknown, Types.GetPlatformAccountPaymentGatewayQueryResult>, 'queryFn'>> = {
};
export function getPlatformAccountPaymentGatewayGETDefaultOptions() {
  return platformAccountPaymentGatewayGETDefaultOptions;
};
export function setPlatformAccountPaymentGatewayGETDefaultOptions(options: typeof platformAccountPaymentGatewayGETDefaultOptions) {
  platformAccountPaymentGatewayGETDefaultOptions = options;
}

export function platformAccountPaymentGatewayGETQueryKey(): QueryKey;
export function platformAccountPaymentGatewayGETQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'Client',
      'platformAccountPaymentGatewayGET',
    ]);
}
export function __platformAccountPaymentGatewayGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.platformAccountPaymentGatewayGET(
axiosConfig    );
}

/**
 * @return Success
 */
export function usePlatformAccountPaymentGatewayGETQuery<TSelectData = Types.GetPlatformAccountPaymentGatewayQueryResult, TError = unknown>(options?: Omit<UseQueryOptions<Types.GetPlatformAccountPaymentGatewayQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePlatformAccountPaymentGatewayGETQuery<TSelectData = Types.GetPlatformAccountPaymentGatewayQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetPlatformAccountPaymentGatewayQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetPlatformAccountPaymentGatewayQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __platformAccountPaymentGatewayGET(context, axiosConfig) : __platformAccountPaymentGatewayGET,
    queryKey: platformAccountPaymentGatewayGETQueryKey(),
    ...platformAccountPaymentGatewayGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetPlatformAccountPaymentGatewayQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return Success
 */
export function setPlatformAccountPaymentGatewayGETData(queryClient: QueryClient, updater: (data: Types.GetPlatformAccountPaymentGatewayQueryResult | undefined) => Types.GetPlatformAccountPaymentGatewayQueryResult, ) {
  queryClient.setQueryData(platformAccountPaymentGatewayGETQueryKey(),
    updater
  );
}

/**
 * @return Success
 */
export function setPlatformAccountPaymentGatewayGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetPlatformAccountPaymentGatewayQueryResult | undefined) => Types.GetPlatformAccountPaymentGatewayQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function pricingsCalculateGETUrl(pricingGuid?: string | undefined, passengers?: number | undefined, promoCodeRequest_PromoCode?: string | undefined, promoCodeRequest_StartDateTime?: Date | undefined, campaignCodeRequest_Code?: string | undefined, campaignCodeRequest_StartDateTime?: Date | undefined): string {
  let url_ = getBaseUrl() + "/pricings/calculate?";
if (pricingGuid === null)
    throw new Error("The parameter 'pricingGuid' cannot be null.");
else if (pricingGuid !== undefined)
    url_ += "PricingGuid=" + encodeURIComponent("" + pricingGuid) + "&";
if (passengers === null)
    throw new Error("The parameter 'passengers' cannot be null.");
else if (passengers !== undefined)
    url_ += "Passengers=" + encodeURIComponent("" + passengers) + "&";
if (promoCodeRequest_PromoCode === null)
    throw new Error("The parameter 'promoCodeRequest_PromoCode' cannot be null.");
else if (promoCodeRequest_PromoCode !== undefined)
    url_ += "PromoCodeRequest.PromoCode=" + encodeURIComponent("" + promoCodeRequest_PromoCode) + "&";
if (promoCodeRequest_StartDateTime === null)
    throw new Error("The parameter 'promoCodeRequest_StartDateTime' cannot be null.");
else if (promoCodeRequest_StartDateTime !== undefined)
    url_ += "PromoCodeRequest.StartDateTime=" + encodeURIComponent(promoCodeRequest_StartDateTime ? "" + promoCodeRequest_StartDateTime.toISOString() : "") + "&";
if (campaignCodeRequest_Code === null)
    throw new Error("The parameter 'campaignCodeRequest_Code' cannot be null.");
else if (campaignCodeRequest_Code !== undefined)
    url_ += "CampaignCodeRequest.Code=" + encodeURIComponent("" + campaignCodeRequest_Code) + "&";
if (campaignCodeRequest_StartDateTime === null)
    throw new Error("The parameter 'campaignCodeRequest_StartDateTime' cannot be null.");
else if (campaignCodeRequest_StartDateTime !== undefined)
    url_ += "CampaignCodeRequest.StartDateTime=" + encodeURIComponent(campaignCodeRequest_StartDateTime ? "" + campaignCodeRequest_StartDateTime.toISOString() : "") + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let pricingsCalculateGETDefaultOptions: Omit<UseQueryOptions<Types.GetMarketplaceCalculatedPriceQueryResult, unknown, Types.GetMarketplaceCalculatedPriceQueryResult>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetMarketplaceCalculatedPriceQueryResult, unknown, Types.GetMarketplaceCalculatedPriceQueryResult>, 'queryFn'>> = {
};
export function getPricingsCalculateGETDefaultOptions() {
  return pricingsCalculateGETDefaultOptions;
};
export function setPricingsCalculateGETDefaultOptions(options: typeof pricingsCalculateGETDefaultOptions) {
  pricingsCalculateGETDefaultOptions = options;
}

export function pricingsCalculateGETQueryKey(dto: PricingsCalculateGETQueryParameters): QueryKey;
export function pricingsCalculateGETQueryKey(pricingGuid?: string | undefined, passengers?: number | undefined, promoCodeRequest_PromoCode?: string | undefined, promoCodeRequest_StartDateTime?: Date | undefined, campaignCodeRequest_Code?: string | undefined, campaignCodeRequest_StartDateTime?: Date | undefined): QueryKey;
export function pricingsCalculateGETQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { pricingGuid, passengers, promoCodeRequest_PromoCode, promoCodeRequest_StartDateTime, campaignCodeRequest_Code, campaignCodeRequest_StartDateTime,  } = params[0] as PricingsCalculateGETQueryParameters;

    return trimArrayEnd([
        'Client',
        'pricingsCalculateGET',
        pricingGuid as any,
        passengers as any,
        promoCodeRequest_PromoCode as any,
        promoCodeRequest_StartDateTime as any,
        campaignCodeRequest_Code as any,
        campaignCodeRequest_StartDateTime as any,
      ]);
  } else {
    return trimArrayEnd([
        'Client',
        'pricingsCalculateGET',
        ...params
      ]);
  }
}
export function __pricingsCalculateGET(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.pricingsCalculateGET(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as Date | undefined,       context.queryKey[6] as string | undefined,       context.queryKey[7] as Date | undefined,axiosConfig    );
}

export function usePricingsCalculateGETQuery<TSelectData = Types.GetMarketplaceCalculatedPriceQueryResult, TError = unknown>(dto: PricingsCalculateGETQueryParameters, options?: Omit<UseQueryOptions<Types.GetMarketplaceCalculatedPriceQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param pricingGuid (optional) 
 * @param passengers (optional) 
 * @param promoCodeRequest_PromoCode (optional) 
 * @param promoCodeRequest_StartDateTime (optional) 
 * @param campaignCodeRequest_Code (optional) 
 * @param campaignCodeRequest_StartDateTime (optional) 
 * @return Success
 */
export function usePricingsCalculateGETQuery<TSelectData = Types.GetMarketplaceCalculatedPriceQueryResult, TError = unknown>(pricingGuid?: string | undefined, passengers?: number | undefined, promoCodeRequest_PromoCode?: string | undefined, promoCodeRequest_StartDateTime?: Date | undefined, campaignCodeRequest_Code?: string | undefined, campaignCodeRequest_StartDateTime?: Date | undefined, options?: Omit<UseQueryOptions<Types.GetMarketplaceCalculatedPriceQueryResult, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function usePricingsCalculateGETQuery<TSelectData = Types.GetMarketplaceCalculatedPriceQueryResult, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetMarketplaceCalculatedPriceQueryResult, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let pricingGuid: any = undefined;
  let passengers: any = undefined;
  let promoCodeRequest_PromoCode: any = undefined;
  let promoCodeRequest_StartDateTime: any = undefined;
  let campaignCodeRequest_Code: any = undefined;
  let campaignCodeRequest_StartDateTime: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ pricingGuid, passengers, promoCodeRequest_PromoCode, promoCodeRequest_StartDateTime, campaignCodeRequest_Code, campaignCodeRequest_StartDateTime,  } = params[0] as PricingsCalculateGETQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [pricingGuid, passengers, promoCodeRequest_PromoCode, promoCodeRequest_StartDateTime, campaignCodeRequest_Code, campaignCodeRequest_StartDateTime, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetMarketplaceCalculatedPriceQueryResult, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __pricingsCalculateGET(context, axiosConfig) : __pricingsCalculateGET,
    queryKey: pricingsCalculateGETQueryKey(pricingGuid, passengers, promoCodeRequest_PromoCode, promoCodeRequest_StartDateTime, campaignCodeRequest_Code, campaignCodeRequest_StartDateTime),
    ...pricingsCalculateGETDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetMarketplaceCalculatedPriceQueryResult, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param pricingGuid (optional) 
 * @param passengers (optional) 
 * @param promoCodeRequest_PromoCode (optional) 
 * @param promoCodeRequest_StartDateTime (optional) 
 * @param campaignCodeRequest_Code (optional) 
 * @param campaignCodeRequest_StartDateTime (optional) 
 * @return Success
 */
export function setPricingsCalculateGETData(queryClient: QueryClient, updater: (data: Types.GetMarketplaceCalculatedPriceQueryResult | undefined) => Types.GetMarketplaceCalculatedPriceQueryResult, pricingGuid?: string | undefined, passengers?: number | undefined, promoCodeRequest_PromoCode?: string | undefined, promoCodeRequest_StartDateTime?: Date | undefined, campaignCodeRequest_Code?: string | undefined, campaignCodeRequest_StartDateTime?: Date | undefined) {
  queryClient.setQueryData(pricingsCalculateGETQueryKey(pricingGuid, passengers, promoCodeRequest_PromoCode, promoCodeRequest_StartDateTime, campaignCodeRequest_Code, campaignCodeRequest_StartDateTime),
    updater
  );
}

/**
 * @param pricingGuid (optional) 
 * @param passengers (optional) 
 * @param promoCodeRequest_PromoCode (optional) 
 * @param promoCodeRequest_StartDateTime (optional) 
 * @param campaignCodeRequest_Code (optional) 
 * @param campaignCodeRequest_StartDateTime (optional) 
 * @return Success
 */
export function setPricingsCalculateGETDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetMarketplaceCalculatedPriceQueryResult | undefined) => Types.GetMarketplaceCalculatedPriceQueryResult) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function pricingsGuidPromoCodeValidationPOSTUrl(guid: string): string {
  let url_ = getBaseUrl() + "/pricings/{guid}/promo-code/validation";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function pricingsGuidPromoCodeValidationPOSTMutationKey(guid: string): MutationKey {
  return trimArrayEnd([
      'Client',
      'pricingsGuidPromoCodeValidationPOST',
      guid as any,
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePricingsGuidPromoCodeValidationPOSTMutation<TContext>(guid: string, options?: Omit<UseMutationOptions<Types.ValidatePromoCodeResult, unknown, Types.ValidateOrderingPromoCodeCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ValidatePromoCodeResult, unknown, Types.ValidateOrderingPromoCodeCommand, TContext> {
  const key = pricingsGuidPromoCodeValidationPOSTMutationKey(guid);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ValidateOrderingPromoCodeCommand) => Client.pricingsGuidPromoCodeValidationPOST(guid, body),
    mutationKey: key,
  });
}
  
type PricingsGuidPromoCodeValidationPOST__MutationParameters = PricingsGuidPromoCodeValidationPOSTQueryParameters & {
  body: Types.ValidateOrderingPromoCodeCommand;
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePricingsGuidPromoCodeValidationPOSTMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ValidatePromoCodeResult, unknown, PricingsGuidPromoCodeValidationPOST__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PricingsGuidPromoCodeValidationPOSTQueryParameters}): UseMutationResult<Types.ValidatePromoCodeResult, unknown, PricingsGuidPromoCodeValidationPOST__MutationParameters, TContext> {
  const key = pricingsGuidPromoCodeValidationPOSTMutationKey(options?.parameters?.guid!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PricingsGuidPromoCodeValidationPOST__MutationParameters) => Client.pricingsGuidPromoCodeValidationPOST(data.guid ?? options?.parameters?.guid!, data.body),
  mutationKey: key,
});
}
  
export function pricingsGuidCampaignValidationPOSTUrl(guid: string): string {
  let url_ = getBaseUrl() + "/pricings/{guid}/campaign/validation";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function pricingsGuidCampaignValidationPOSTMutationKey(guid: string): MutationKey {
  return trimArrayEnd([
      'Client',
      'pricingsGuidCampaignValidationPOST',
      guid as any,
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePricingsGuidCampaignValidationPOSTMutation<TContext>(guid: string, options?: Omit<UseMutationOptions<Types.ValidateCampaignResult, unknown, Types.ValidateCampaignCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ValidateCampaignResult, unknown, Types.ValidateCampaignCommand, TContext> {
  const key = pricingsGuidCampaignValidationPOSTMutationKey(guid);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ValidateCampaignCommand) => Client.pricingsGuidCampaignValidationPOST(guid, body),
    mutationKey: key,
  });
}
  
type PricingsGuidCampaignValidationPOST__MutationParameters = PricingsGuidCampaignValidationPOSTQueryParameters & {
  body: Types.ValidateCampaignCommand;
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePricingsGuidCampaignValidationPOSTMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ValidateCampaignResult, unknown, PricingsGuidCampaignValidationPOST__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PricingsGuidCampaignValidationPOSTQueryParameters}): UseMutationResult<Types.ValidateCampaignResult, unknown, PricingsGuidCampaignValidationPOST__MutationParameters, TContext> {
  const key = pricingsGuidCampaignValidationPOSTMutationKey(options?.parameters?.guid!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PricingsGuidCampaignValidationPOST__MutationParameters) => Client.pricingsGuidCampaignValidationPOST(data.guid ?? options?.parameters?.guid!, data.body),
  mutationKey: key,
});
}
  
export function pricingsGuidCampaignValidationByCustomerEmailPOSTUrl(guid: string): string {
  let url_ = getBaseUrl() + "/pricings/{guid}/campaign/validation/by-customer-email";
if (guid === undefined || guid === null)
  throw new Error("The parameter 'guid' must be defined.");
url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function pricingsGuidCampaignValidationByCustomerEmailPOSTMutationKey(guid: string): MutationKey {
  return trimArrayEnd([
      'Client',
      'pricingsGuidCampaignValidationByCustomerEmailPOST',
      guid as any,
    ]);
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePricingsGuidCampaignValidationByCustomerEmailPOSTMutation<TContext>(guid: string, options?: Omit<UseMutationOptions<void, unknown, Types.ValidateCampaignByEmailCommand, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ValidateCampaignByEmailCommand, TContext> {
  const key = pricingsGuidCampaignValidationByCustomerEmailPOSTMutationKey(guid);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ValidateCampaignByEmailCommand) => Client.pricingsGuidCampaignValidationByCustomerEmailPOST(guid, body),
    mutationKey: key,
  });
}
  
type PricingsGuidCampaignValidationByCustomerEmailPOST__MutationParameters = PricingsGuidCampaignValidationByCustomerEmailPOSTQueryParameters & {
  body: Types.ValidateCampaignByEmailCommand;
}

/**
 * @param body (optional) 
 * @return Success
 */
export function usePricingsGuidCampaignValidationByCustomerEmailPOSTMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PricingsGuidCampaignValidationByCustomerEmailPOST__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PricingsGuidCampaignValidationByCustomerEmailPOSTQueryParameters}): UseMutationResult<void, unknown, PricingsGuidCampaignValidationByCustomerEmailPOST__MutationParameters, TContext> {
  const key = pricingsGuidCampaignValidationByCustomerEmailPOSTMutationKey(options?.parameters?.guid!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PricingsGuidCampaignValidationByCustomerEmailPOST__MutationParameters) => Client.pricingsGuidCampaignValidationByCustomerEmailPOST(data.guid ?? options?.parameters?.guid!, data.body),
  mutationKey: key,
});
}
  
export function testTestSentryPUTUrl(): string {
  let url_ = getBaseUrl() + "/test/test-sentry";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function testTestSentryPUTMutationKey(): MutationKey {
  return trimArrayEnd([
      'Client',
      'testTestSentryPUT',
    ]);
}

/**
 * @return No Content
 */
export function useTestTestSentryPUTMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = testTestSentryPUTMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.testTestSentryPUT(),
    mutationKey: key,
  });
}